import redirectInterceptor from "@/interceptors/redirect_interceptor";
import { DATA_OVERVIEW_ENDPOINT } from "@/domain/data_overview/data";

export const getDataOverviewList = async () => {
  const response = await redirectInterceptor.get(DATA_OVERVIEW_ENDPOINT, {
    headers: {
      Authorization: localStorage.getItem("quad_token"),
    },
  });

  return response.data;
};
